import React from 'react'

interface WarningEllipsesProps {
  size?: number
  color?: string
  secondColor?: string
  className?: string
  style?: React.CSSProperties
}

export const WarningEllipses: React.FC<WarningEllipsesProps> = ({
  size = 64,
  color = '#F32C3E', // pinkish_red
  secondColor = '#fff',
  className,
  style,
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 111 110"
      fill="none"
      className={className}
      style={style}
      {...rest}
    >
      {/* Outer circle with low opacity */}
      <circle cx="55.5" cy="55" r="55" fill={color} fillOpacity="0.1" />

      {/* Middle circle with medium opacity */}
      <circle cx="55.5" cy="55" r="45" fill={color} fillOpacity="0.4" />

      {/* Inner solid circle */}
      <rect x="23.5" y="23" width="64" height="64" rx="32" fill={color} />

      {/* Exclamation mark - vertical line */}
      <path
        d="M55.5 75c11 0 20-9 20-20s-9-20-20-20-20 9-20 20 9 20 20 20zM55.5 47v10"
        stroke={secondColor}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Exclamation mark - dot */}
      <path
        d="M55.488 63h.018"
        stroke={secondColor}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
